<div class="w-full h-full object-center object-cover relative" #gMapContainer>
  <div class="flex flex-col absolute bottom-6 right-6 z-10 gap-4">
    <button class="rounded-full bg-white border border-gray-400 w-[48px] h-[48px]" (click)="zoomIn()"><i
        class="text-[24px] text-secondary-700 icon-plus"></i></button>
    <button class="rounded-full bg-white border border-gray-400 w-[48px] h-[48px]" (click)="zoomOut()"><i
        class="text-[24px] text-secondary-700 icon-minus"></i></button>
  </div>
  <google-map [mapId]="'2ee4cac2a3e9c60'" [options]="mapOptions" #propertyMap [width]="gMapContainer.clientWidth"
    [height]="gMapContainer.clientHeight" (mapClick)="onMapClick()" (mapInitialized)="mapInitialized($event)">
    <map-marker-clusterer #cluster [options]="{
        styles: [
          {
            textColor: 'white',
            textSize: 16,
            url: '../../assets/m1.png',
            height: 53,
            width: 53,
          },
        ],
      }">
      @for (marker of markers$ | async; let i = $index; track marker.id) {
      <map-marker #mrk="mapMarker" [position]="marker.position" [label]="marker.title" class="text-white !bg-secondary"
        [icon]="marker.icon" (mapClick)="markerClicked(mrk, marker)">
      </map-marker>
      }
      <map-info-window [options]="infoWindowOptions">
        <app-map-info-window [selectedMarker]="selectedMarker"></app-map-info-window>

      </map-info-window>
    </map-marker-clusterer>
  </google-map>
</div>